var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Banner'),_c('h1',[_vm._v("Advisory Board")]),_c('div',{staticClass:"container"},_vm._l((_vm.profiles),function(profile,i){return _c('Profile',{key:i,attrs:{"data":profile}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }